const THORNS = [
  { angle: -90, length: 15 },
  { angle: -52, length: 9 },
  { angle: -18, length: 12 },
  { angle: 22, length: 7 },
  { angle: 61, length: 11 },
  { angle: 104, length: 8 },
  { angle: 141, length: 13 },
  { angle: 178, length: 9 },
  { angle: 214, length: 12 },
];

const SHARDS = Array.from({ length: 7 }, (_, index) => index);

function thorn(angleDeg: number, length: number) {
  const rad = (angleDeg * Math.PI) / 180;
  const base = 37;
  const spread = 0.07;
  const p = (r: number, a: number) => `${(50 + Math.cos(a) * r).toFixed(1)} ${(50 + Math.sin(a) * r).toFixed(1)}`;
  return `M ${p(base, rad - spread)} L ${p(base + length, rad)} L ${p(base, rad + spread)} Z`;
}

export function SenitaHalo({ idPrefix, className = 'fx__halo-slot fx__halo-slot--senita' }: { idPrefix: string; className?: string }) {
  const grad = `${idPrefix}-shalo`;
  return (
    <span className={className}>
      <span className="fx__halo-aura" />
      <svg className="fx__halo fx__halo--senita" viewBox="0 0 100 100" aria-hidden="true">
        <defs>
          <linearGradient id={grad} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#ffd27a" />
            <stop offset="35%" stopColor="#b02a6b" />
            <stop offset="70%" stopColor="#3b0d66" />
            <stop offset="100%" stopColor="#9a5cff" />
          </linearGradient>
        </defs>
        <g className="fx__halo-thorns" fill={`url(#${grad})`}>
          {THORNS.map((spike) => (
            <path key={spike.angle} d={thorn(spike.angle, spike.length)} />
          ))}
        </g>
        <circle cx="50" cy="50" r="36" fill="none" stroke="#0a0212" strokeWidth="6" strokeDasharray="38 4 22 7 51 3 31 9 40" />
        <circle cx="50" cy="50" r="36" fill="none" stroke={`url(#${grad})`} strokeWidth="3.2" strokeDasharray="38 4 22 7 51 3 31 9 40" />
        <circle
          className="fx__halo-runes"
          cx="50"
          cy="50"
          r="29"
          fill="none"
          stroke="#d9a8ff"
          strokeWidth="0.8"
          strokeDasharray="5 3 1 3"
          opacity="0.85"
        />
        <g className="fx__halo-shards">
          {SHARDS.map((index) => {
            const angle = (index / SHARDS.length) * Math.PI * 2;
            const radius = index % 2 === 0 ? 45 : 47.5;
            const x = 50 + Math.cos(angle) * radius;
            const y = 50 + Math.sin(angle) * radius;
            return (
              <rect
                key={index}
                x={x - 1.4}
                y={y - 2.6}
                width="2.8"
                height="5.2"
                fill={index % 3 === 0 ? '#ffd27a' : '#c47bff'}
                transform={`rotate(${(angle * 180) / Math.PI + 20} ${x} ${y})`}
              />
            );
          })}
        </g>
      </svg>
    </span>
  );
}
